import React from 'react';

interface CallToActionProps {
  onRequestDemo: () => void;
}

const CallToAction: React.FC<CallToActionProps> = ({ onRequestDemo }) => {
  return (
    <section className="bg-dark py-20 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8">
          Want to Connect?
        </h2>
        <button
          onClick={onRequestDemo}
          className="bg-primary hover:bg-primary-dark text-white font-medium px-8 py-4 rounded-full inline-block transition-colors"
        >
          Request Demo
        </button>
      </div>
    </section>
  );
};

export default CallToAction;